/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Open_Screen_SettingsInputs */

const en_us2_chat_open_screen_settings = /** @type {(inputs: Chat_Open_Screen_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open settings`)
};

const pt_br2_chat_open_screen_settings = /** @type {(inputs: Chat_Open_Screen_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir configurações`)
};

const es_419_chat_open_screen_settings = /** @type {(inputs: Chat_Open_Screen_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir configuración`)
};

const pt_pt2_chat_open_screen_settings = /** @type {(inputs: Chat_Open_Screen_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir definições`)
};

const fr_fr2_chat_open_screen_settings = /** @type {(inputs: Chat_Open_Screen_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir les réglages`)
};

const de_de2_chat_open_screen_settings = /** @type {(inputs: Chat_Open_Screen_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen öffnen`)
};

const it_it2_chat_open_screen_settings = /** @type {(inputs: Chat_Open_Screen_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri le impostazioni`)
};

/**
* | output |
* | --- |
* | "Open settings" |
*
* @param {Chat_Open_Screen_SettingsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const chat_open_screen_settings = /** @type {((inputs?: Chat_Open_Screen_SettingsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Open_Screen_SettingsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_chat_open_screen_settings(inputs)
	if (locale === "es-419") return es_419_chat_open_screen_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_chat_open_screen_settings(inputs)
	if (locale === "fr-FR") return fr_fr2_chat_open_screen_settings(inputs)
	if (locale === "de-DE") return de_de2_chat_open_screen_settings(inputs)
	if (locale === "it-IT") return it_it2_chat_open_screen_settings(inputs)
	return en_us2_chat_open_screen_settings(inputs)
});
export { chat_open_screen_settings as "chat.open_screen.settings" }